"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAllLinks = exports.removeLink = exports.saveLink = exports.loadLinks = void 0;
var parseYouTubeUrl_1 = require("./parseYouTubeUrl");
var STORAGE_KEY = 'stremio-web-links-v1';
var readAll = function () {
    try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return [];
        }
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch (_a) {
        return [];
    }
};
var writeAll = function (links) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(links));
};
var loadLinks = function () {
    return readAll().slice().sort(function (a, b) { return b.updatedAt - a.updatedAt; });
};
exports.loadLinks = loadLinks;
var saveLink = function (input) {
    var parsed = (0, parseYouTubeUrl_1.parseYouTubeUrl)(input.url);
    if (!parsed) {
        throw new Error('Use a youtube.com / youtu.be video, playlist, /channel/UC…, or /user/… URL. @handles need a channel ID URL for embed.');
    }
    var now = Date.now();
    var links = readAll();
    var title = input.title.trim() || parsed.suggestedTitle;
    if (input.id) {
        var index = links.findIndex(function (link) { return link.id === input.id; });
        if (index === -1) {
            throw new Error('Link not found');
        }
        var updated = __assign(__assign({}, links[index]), { title: title, url: input.url.trim(), embedUrl: parsed.embedUrl, kind: parsed.kind, updatedAt: now });
        links[index] = updated;
        writeAll(links);
        return updated;
    }
    var created = {
        id: "link_".concat(now, "_").concat(Math.random().toString(36).slice(2, 8)),
        title: title,
        url: input.url.trim(),
        embedUrl: parsed.embedUrl,
        kind: parsed.kind,
        createdAt: now,
        updatedAt: now,
    };
    links.push(created);
    writeAll(links);
    return created;
};
exports.saveLink = saveLink;
var removeLink = function (id) {
    writeAll(readAll().filter(function (link) { return link.id !== id; }));
};
exports.removeLink = removeLink;
var clearAllLinks = function () {
    writeAll([]);
};
exports.clearAllLinks = clearAllLinks;
